import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ModuleGate from "../Components/Common/ModuleGate";
import { SYSTEM_MODULE_CODES } from "../helpers/functions/systemModules";

//Reporting
const ReportingPage = lazy(() => import(/* webpackChunkName: "ReportingPage" */ "../pages/Reporting/index"));

//Advanced Search
const AdvancedSearch = lazy(() => import(/* webpackChunkName: "AdvancedSearch" */ "../pages/AdvancedSearch/AdvancedSearch"));

//Onboarding checklist templates
const OnboardingTemplates = lazy(() => import(/* webpackChunkName: "OnboardingTemplates" */ "../pages/OnboardingTemplates/index"));

//Crmit  Email Inbox
const CrmitMailInbox = lazy(() => import(/* webpackChunkName: "CrmitMailInbox" */ "../pages/EmailInbox"));

//CHat

const CalendarCrmIT = lazy(() => import(/* webpackChunkName: "CalendarCrmIT" */ "../pages/Calendar"));

// Tasks
const TasksCrmIT = lazy(() => import(/* webpackChunkName: "TasksCrmIT" */ "../pages/Tasks/index"));
const WeeklyTasks = lazy(() => import(/* webpackChunkName: "WeeklyTasks" */ "../pages/Tasks/WeeklyTasks/"));
//Transactions

//Jobs
const CrmJobsList = lazy(() => import(/* webpackChunkName: "CrmJobsList" */ "../pages/Jobs/index"));
const SingleJob = lazy(() => import(/* webpackChunkName: "SingleJob" */ "../pages/Jobs/singleJob/singleJob"));
const PDFJobSheet = lazy(() => import(/* webpackChunkName: "PDFJobSheet" */ "../pages/Jobs/pdfJobSheet/pdfJobSheet"));
const CrmJobsUninvoicedList = lazy(() => import(/* webpackChunkName: "CrmJobsUninvoicedList" */ "../pages/Jobs/uninvoiced/list"));
// Change #100386 - open jobs not updated in X days
const CrmJobsStaleList = lazy(() => import(/* webpackChunkName: "CrmJobsStaleList" */ "../pages/Jobs/stale"));
//Dashboard
const CrmDashboard = lazy(() => import(/* webpackChunkName: "CrmDashboard" */ "../pages/Dashboard/index"));
const DashboardBuilder = lazy(() => import(/* webpackChunkName: "DashboardBuilder" */ "../pages/DashboardBuilder/index"));
const RecentlyViewed = lazy(() => import(/* webpackChunkName: "RecentlyViewed" */ "../pages/RecentlyViewed/index"));
const Dashboard2ndEdition = lazy(() => import(/* webpackChunkName: "Dashboard2ndEdition" */ "../pages/Dashboard/Dashboard2ndEdition/index"));
//Invoices
//video call
const VideoCallPage = lazy(() => import(/* webpackChunkName: "VideoCallPage" */ "../pages/VideoCall"));
// invoices
//InvoiceListV2
const InvoiceListV2 = lazy(() => import(/* webpackChunkName: "InvoiceListV2" */ "../pages/Invoices/InvoiceList/InvoiceList"));
const InvoiceListCrmIT = lazy(() => import(/* webpackChunkName: "InvoiceListCrmIT" */ "../pages/Invoices/InvoiceList"));
const InvoiceCreateCrmIT = lazy(() => import(/* webpackChunkName: "InvoiceCreateCrmIT" */ "../pages/Invoices/InvoiceCreate"));
const InvoiceDetailsCrmIT = lazy(() => import(/* webpackChunkName: "InvoiceDetailsCrmIT" */ "../pages/Invoices/InvoiceDetails"));

//login

// User Profile
const UserProfile = lazy(() => import(/* webpackChunkName: "UserProfile" */ "../pages/Authentication/user-profile"));

// Prototyping
const Prototyping = lazy(() => import(/* webpackChunkName: "Prototyping" */ "../pages/Prototyping"));
// Time Entries
const TimeEntries = lazy(() => import(/* webpackChunkName: "TimeEntries" */ "../pages/TimeEntries"));
//TimeEntriesSummary
const TimeEntriesSummary = lazy(() => import(/* webpackChunkName: "TimeEntriesSummary" */ "../pages/TimeEntriesSummary"));
// Customer paths
// Customer Single
const CustomerSingle = lazy(() => import(/* webpackChunkName: "CustomerSingle" */ "../pages/Customer/single/index"));
// Customer List
const CustomerList = lazy(() => import(/* webpackChunkName: "CustomerList" */ "../pages/Customer/list/index"));
// Customer Balance List
const CustomerBalanceList = lazy(() => import(/* webpackChunkName: "CustomerBalanceList" */ "../pages/Customer/balance/"));
// Payroll
const PayrollRunList = lazy(() => import(/* webpackChunkName: "PayrollRunList" */ "../pages/Payroll/list"));
const PayrollNewRun = lazy(() => import(/* webpackChunkName: "PayrollNewRun" */ "../pages/Payroll/new"));
const PayrollRunDetail = lazy(() => import(/* webpackChunkName: "PayrollRunDetail" */ "../pages/Payroll/detail"));
const PayrollPayslip = lazy(() => import(/* webpackChunkName: "PayrollPayslip" */ "../pages/Payroll/payslip"));
const PayrollHmrcSettings = lazy(() => import(/* webpackChunkName: "PayrollHmrcSettings" */ "../pages/Payroll/hmrcSettings"));
// Loyalty
const Loyalty = lazy(() => import(/* webpackChunkName: "Loyalty" */ "../pages/Loyalty"));
// Loyalty Balances
const LoyaltyBalances = lazy(() => import(/* webpackChunkName: "LoyaltyBalances" */ "../pages/Loyalty/loyaltyBalances"));
// Loyalty Vouchers
const LoyaltyVouchers = lazy(() => import(/* webpackChunkName: "LoyaltyVouchers" */ "../pages/Loyalty/loyaltyVouchers"));
// Loyalty Dashboard
const LoyaltyDashboard = lazy(() => import(/* webpackChunkName: "LoyaltyDashboard" */ "../pages/LoyaltyDashboard/"));
// Business Overview
const BusinessOverview = lazy(() => import(/* webpackChunkName: "BusinessOverview" */ "../pages/BusinessOverview/"));
const FinanceOverview = lazy(() => import(/* webpackChunkName: "FinanceOverview" */ "../pages/FinanceOverview/"));
const RecurringRevenue = lazy(() => import(/* webpackChunkName: "RecurringRevenue" */ "../pages/RecurringRevenue/"));
const PlatformMrr = lazy(() => import(/* webpackChunkName: "PlatformMrr" */ "../pages/PlatformMrr/"));
// Loyalty Terminal
const LoyaltyTerminal = lazy(() => import(/* webpackChunkName: "LoyaltyTerminal" */ "../pages/Loyalty/terminal"));
// Loyalty Portals (admin CRUD)
const LoyaltyPortals = lazy(() => import(/* webpackChunkName: "LoyaltyPortals" */ "../pages/Loyalty/portals"));
// Bank

// Bank List
const BankList = lazy(() => import(/* webpackChunkName: "BankList" */ "../pages/BankAccount/bankList/index"));
// Bank Single
const BankSingle = lazy(() => import(/* webpackChunkName: "BankSingle" */ "../pages/BankAccount/bankSingle/index"));
const SingleTask = lazy(() => import(/* webpackChunkName: "SingleTask" */ "../pages/Tasks/single/singleTask"));
const AllBankTransactions = lazy(() => import(/* webpackChunkName: "AllBankTransactions" */ "../pages/BankAccount/allBankTransactions/index"));
const AllocationSingle = lazy(() => import(/* webpackChunkName: "AllocationSingle" */ "../pages/BankAccount/allocationSingle/index"));
// FAQ
const FaqsCrmIT = lazy(() => import(/* webpackChunkName: "FaqsCrmIT" */ "../pages/Faq/"));
// import ProductList
const ProductList = lazy(() => import(/* webpackChunkName: "ProductList" */ "../pages/Product/list/"));
// Contract
const Contract = lazy(() => import(/* webpackChunkName: "Contract" */ "../pages/Contract/list/"));
const ContractItemsList = lazy(() => import(/* webpackChunkName: "ContractItemsList" */ "../pages/Contract/items/list/"));
// Purchase
const PurchaseList = lazy(() => import(/* webpackChunkName: "PurchaseList" */ "../pages/Purchase/list/"));
const PurchaseDetails = lazy(() => import(/* webpackChunkName: "PurchaseDetails" */ "../pages/Purchase/details"));
const CreatePurchase = lazy(() => import(/* webpackChunkName: "CreatePurchase" */ "../pages/Purchase/editCreate/Create"));
const SuppliersList = lazy(() => import(/* webpackChunkName: "SuppliersList" */ "../pages/Suppliers/List/"));
const SupplierDetails = lazy(() => import(/* webpackChunkName: "SupplierDetails" */ "../pages/Suppliers/Details/"));
//purchase order
const PurchaseOrderList = lazy(() => import(/* webpackChunkName: "PurchaseOrderList" */ "../pages/PurchaseOrder/list/"));
// Supplier Balances
const SupplierBalanceList = lazy(() => import(/* webpackChunkName: "SupplierBalanceList" */ "../pages/Suppliers/balance/"));
// Task 24319 - every supplier portal flagged as a purchase-invoice download
// area, in one list with an Open All button.
const PurchaseInvoiceLinks = lazy(() => import(/* webpackChunkName: "PurchaseInvoiceLinks" */ "../pages/Suppliers/PurchaseInvoiceLinks"));
// Task 24509 - the engineer's own day, built for a phone.
const MyDay = lazy(() => import(/* webpackChunkName: "MyDay" */ "../pages/MyDay"));
const MyVehicles = lazy(() => import(/* webpackChunkName: "MyVehicles" */ "../pages/MyVehicles"));

const OpportunitiesList = lazy(() => import(/* webpackChunkName: "OpportunitiesList" */ "../pages/Opportunities/list"));
const OpportunityDetails = lazy(() => import(/* webpackChunkName: "OpportunityDetails" */ "../pages/Opportunities/Details"));
// Quote
const QuoteList = lazy(() => import(/* webpackChunkName: "QuoteList" */ "../pages/Quotes/List/"));
const QuoteDetails = lazy(() => import(/* webpackChunkName: "QuoteDetails" */ "../pages/Quotes/details/QuoteDetails"));
const QuoteCreate = lazy(() => import(/* webpackChunkName: "QuoteCreate" */ "../pages/Quotes/editCreate/index"));
const ContactPersonLookupList = lazy(() => import(/* webpackChunkName: "ContactPersonLookupList" */ "../pages/ContactPersonLookup/List"));
const WeeklyTasksKanBan = lazy(() => import(/* webpackChunkName: "WeeklyTasksKanBan" */ "../pages/Tasks/WeeklyTasksKanban"));
// Contact Person lookup list
// import WeeklyTasksKanBan
// import ProfitAndLoss
const ProfitAndLoss = lazy(() => import(/* webpackChunkName: "ProfitAndLoss" */ "../pages/ProfitAndLoss"));
// Change #100017 - the management view of the P&L (tax, dividends, VAT).
const BusinessProfitAndLoss = lazy(() => import(/* webpackChunkName: "BusinessProfitAndLoss" */ "../pages/ProfitAndLoss/business"));
//XlsPrototyping
const XlsPrototyping = lazy(() => import(/* webpackChunkName: "XlsPrototyping" */ "../pages/Prototyping/xls/xlsPrototyping"));
const PaymentStatus = lazy(() => import(/* webpackChunkName: "PaymentStatus" */ "../pages/charges/subscribeFirstTime/paymentStatus"));
const Settings = lazy(() => import(/* webpackChunkName: "Settings" */ "../pages/Settings"));
// Import DunningList
const DunningList = lazy(() => import(/* webpackChunkName: "DunningList" */ "../pages/Dunning/list/"));
// Change #100064 - what the dunning engine would do right now (read-only).
const DunningPreview = lazy(() => import(/* webpackChunkName: "DunningPreview" */ "../pages/Dunning/preview/"));
// Import DunningSingle
const DunningSingle = lazy(() => import(/* webpackChunkName: "DunningSingle" */ "../pages/Dunning/single/"));
// Import DunningLockList
const DunningLockList = lazy(() => import(/* webpackChunkName: "DunningLockList" */ "../pages/Dunning/lockList/"));
const StaffList = lazy(() => import(/* webpackChunkName: "StaffList" */ "../pages/Staff/list/"));
//StaffDetails
const StaffDetails = lazy(() => import(/* webpackChunkName: "StaffDetails" */ "../pages/Staff/details/"));
const StaffQualificationsCertifications = lazy(() => import(/* webpackChunkName: "StaffQualificationsCertifications" */ "../pages/Staff/QualificationsCertifications"));
const CredentialCatalog = lazy(() => import(/* webpackChunkName: "CredentialCatalog" */ "../pages/Settings/company/staff/CredentialCatalog"));
const ChangeTracking = lazy(() => import(/* webpackChunkName: "ChangeTracking" */ "../pages/Settings/company/changeTracking"));
const CustomerAssetSettings = lazy(() => import(/* webpackChunkName: "CustomerAssetSettings" */ "../pages/Settings/company/customerAssets"));
const CustomerAssetDetails = lazy(() => import(/* webpackChunkName: "CustomerAssetDetails" */ "../pages/Customer/single/customerAssets/CustomerAssetDetails"));
//AssetDetails
const AssetDetails = lazy(() => import(/* webpackChunkName: "AssetDetails" */ "../pages/Asset/details/"));
//SystemDeviceHardwareDetails (POS hardware + Stripe reader status)
const SystemDeviceHardwareDetails = lazy(() => import(/* webpackChunkName: "SystemDeviceHardwareDetails" */ "../pages/POS/SystemDeviceHardware/details/"));
//GuidedOnboarding
const GuidedOnboarding = lazy(() => import(/* webpackChunkName: "GuidedOnboarding" */ "../pages/GuidedOnboarding/"));
//DashboardV2
const DashboardV2 = lazy(() => import(/* webpackChunkName: "DashboardV2" */ "../pages/DashboardV2/"));
//AssetList
const AssetList = lazy(() => import(/* webpackChunkName: "AssetList" */ "../pages/Asset/list/"));
// Knowledgebase (Task 24574) — the company's own documentation area
const KnowledgeBase = lazy(() => import(/* webpackChunkName: "KnowledgeBase" */ "../pages/KnowledgeBase"));
const KnowledgeBaseSpace = lazy(() => import(/* webpackChunkName: "KnowledgeBaseSpace" */ "../pages/KnowledgeBase/Space"));
const KnowledgeBaseArticle = lazy(() => import(/* webpackChunkName: "KnowledgeBaseArticle" */ "../pages/KnowledgeBase/Article"));
const KnowledgeBaseArticleEdit = lazy(() => import(/* webpackChunkName: "KnowledgeBaseArticleEdit" */ "../pages/KnowledgeBase/ArticleEdit"));
const KnowledgeBaseAdmin = lazy(() => import(/* webpackChunkName: "KnowledgeBaseAdmin" */ "../pages/KnowledgeBase/Admin"));
// --- Auth ---
//VerifyEmail
const VerifyEmail = lazy(() => import(/* webpackChunkName: "VerifyEmail" */ "../pages/auth/verifyEmail"));
const CreateCompany = lazy(() => import(/* webpackChunkName: "CreateCompany" */ "../pages/auth/createCompany"));
const InviteJoin = lazy(() => import(/* webpackChunkName: "InviteJoin" */ "../pages/auth/inviteJoin"));
const IntermPage = lazy(() => import(/* webpackChunkName: "IntermPage" */ "../pages/auth/interm"));
const NameDevice = lazy(() => import(/* webpackChunkName: "NameDevice" */ "../pages/auth/nameDevice"));

//BasicPasswResetFromEmail
const BasicPasswResetFromEmail = lazy(() => import(/* webpackChunkName: "BasicPasswResetFromEmail" */ "../pages/AuthenticationInner/PasswordCreate/BasicPasswResetFromEmail"));
//OnBoarding
const OnBoarding = lazy(() => import(/* webpackChunkName: "OnBoarding" */ "../pages/OnBoarding"));
// Liability
//liabilityList
const LiabilityList = lazy(() => import(/* webpackChunkName: "LiabilityList" */ "../pages/Liability/list/"));
const LiabilityDetails = lazy(() => import(/* webpackChunkName: "LiabilityDetails" */ "../pages/Liability/details/"));
const CreateLiability = lazy(() => import(/* webpackChunkName: "CreateLiability" */ "../pages/Liability/editCreate/Create"));
//ProviderList
const ProviderList = lazy(() => import(/* webpackChunkName: "ProviderList" */ "../pages/Provider/List/"));
//VatPeriodExport
const VatPeriodExport = lazy(() => import(/* webpackChunkName: "VatPeriodExport" */ "../pages/VatPeriodExport"));
//YearEndPeriodExport
const YearEndPeriodExport = lazy(() => import(/* webpackChunkName: "YearEndPeriodExport" */ "../pages/YearEndPeriodExport"));
const NoAccess = lazy(() => import(/* webpackChunkName: "NoAccess" */ "../pages/auth/noAccess/index"));
// ReportingDashboard
const ReportingDashboard = lazy(() => import(/* webpackChunkName: "ReportingDashboard" */ "../pages/Dashboard/ReportingDashboard/index"));

// CreateEditStaffIncome
const CreateEditStaffIncome = lazy(() => import(/* webpackChunkName: "CreateEditStaffIncome" */ "../pages/Staff/createStaffIncome/index"));
const AppointmentList = lazy(() => import(/* webpackChunkName: "AppointmentList" */ "../pages/appointment/list"));
//AppointmentList

// email prototype
const EmailInbox = lazy(() => import(/* webpackChunkName: "EmailInbox" */ "../pages/EmailInbox/emailsInbound/index"));
const StaffIncomeList = lazy(() => import(/* webpackChunkName: "StaffIncomeList" */ "../pages/Staff/staffIncomeList"));
const StaffIncomeDetails = lazy(() => import(/* webpackChunkName: "StaffIncomeDetails" */ "../pages/Staff/staffIncomeDetails"));
// foodOrdering
//EventPreOrder
const FoodOrdering = lazy(() => import(/* webpackChunkName: "FoodOrdering" */ "../pages/FoodOrdering/index.js"));
const EventPreOrder = lazy(() => import(/* webpackChunkName: "EventPreOrder" */ "../pages/EventPreOrder/EventPreorderList"));
// SingleEventAdmin
const SingleEventAdmin = lazy(() => import(/* webpackChunkName: "SingleEventAdmin" */ "../pages/EventPreOrder/singleEventAdmin/index.js"));
// Event organisers Page
const OrganisersEventPage = lazy(() => import(/* webpackChunkName: "OrganisersEventPage" */ "../pages/EventPreOrder/organisersEventPage/index.js"));
const EventPreOrderWeekly = lazy(() => import(/* webpackChunkName: "EventPreOrderWeekly" */ "../pages/EventPreOrder/EventPreorderWeekly"));
const BookATable = lazy(() => import(/* webpackChunkName: "BookATable" */ "../pages/BookATable/FrontEndWidget"));
const BookATableAdmin = lazy(() => import(/* webpackChunkName: "BookATableAdmin" */ "../pages/BookATable/Admin"));
const ReservationDiaryV2 = lazy(() => import(/* webpackChunkName: "ReservationDiaryV2" */ "../pages/BookATable/Admin/ReservationDiaryV2"));
const ReservationDiaryV2Settings = lazy(() => import(/* webpackChunkName: "ReservationDiaryV2Settings" */ "../pages/BookATable/Admin/ReservationDiaryV2/Settings"));
const ContractItemUsage = lazy(() => import(/* webpackChunkName: "ContractItemUsage" */ "../pages/Contract/ContractItemUsage"));
const ContractOverview = lazy(() => import(/* webpackChunkName: "ContractOverview" */ "../pages/Contract/overview"));
const ContractPortfolio = lazy(() => import(/* webpackChunkName: "ContractPortfolio" */ "../pages/Contract/portfolio"));
const PurchaseItemList = lazy(() => import(/* webpackChunkName: "PurchaseItemList" */ "../pages/Purchase/itemList"));
const EventPreorderMenu = lazy(() => import(/* webpackChunkName: "EventPreorderMenu" */ "../pages/EventPreOrder/EventPreorderMenu/Index"));
const CompanyUsageList = lazy(() => import(/* webpackChunkName: "CompanyUsageList" */ "../pages/BackEnd/CompanyUsage/list"));
const SlowQueryMonitor = lazy(() => import(/* webpackChunkName: "SlowQueryMonitor" */ "../pages/BackEnd/SlowQueryMonitor"));
// System Wallet (Master DB admin)
const SystemWalletList = lazy(() => import(/* webpackChunkName: "SystemWalletList" */ "../pages/BackEnd/SystemWallet/list"));
const SystemWalletDetail = lazy(() => import(/* webpackChunkName: "SystemWalletDetail" */ "../pages/BackEnd/SystemWallet/detail"));
const SystemWalletServiceTypes = lazy(() => import(/* webpackChunkName: "SystemWalletServiceTypes" */ "../pages/BackEnd/SystemWallet/serviceTypes"));
const SystemWalletServiceRates = lazy(() => import(/* webpackChunkName: "SystemWalletServiceRates" */ "../pages/BackEnd/SystemWallet/serviceRates"));
//CompanyReportList
const CompanyReportList = lazy(() => import(/* webpackChunkName: "CompanyReportList" */ "../pages/BackEnd/CompanyReport/list"));
const CompanyDetails = lazy(() => import(/* webpackChunkName: "CompanyDetails" */ "../pages/BackEnd/CompanyDetails"));
//InvoiceItemList
const InvoiceItemList = lazy(() => import(/* webpackChunkName: "InvoiceItemList" */ "../pages/Invoices/InvoiceItems"));
//GiftVoucher
const GiftVoucher = lazy(() => import(/* webpackChunkName: "GiftVoucher" */ "../pages/GiftVoucher"));

//ecommerce
// GPS
const GPS = lazy(() => import(/* webpackChunkName: "GPS" */ "../pages/GPS"));
// Daily Planner
const DailyPlanner = lazy(() => import(/* webpackChunkName: "DailyPlanner" */ "../pages/DailyPlanner"));
//ClosestToCustomer
const ClosestToCustomer = lazy(() => import(/* webpackChunkName: "ClosestToCustomer" */ "../pages/GPS/closestToCustomer/index"));
//Vehicle List
const VehicleList = lazy(() => import(/* webpackChunkName: "VehicleList" */ "../pages/Vehicle/list"));
//Company Vehicle (fleet)
const CompanyVehicleList = lazy(() => import(/* webpackChunkName: "CompanyVehicleList" */ "../pages/CompanyVehicle/list"));
const CompanyVehicleDetails = lazy(() => import(/* webpackChunkName: "CompanyVehicleDetails" */ "../pages/CompanyVehicle/details"));
// PartnersList
const PartnersList = lazy(() => import(/* webpackChunkName: "PartnersList" */ "../pages/partners/list"));
// Helper variables
//VoiceToText
const VoiceToText = lazy(() => import(/* webpackChunkName: "VoiceToText" */ "../pages/VoiceToText"));
const RegisterGuestToEvent = lazy(() => import(/* webpackChunkName: "RegisterGuestToEvent" */ "../pages/EventPreOrder/RegisterGuestToEvent"));
const VehicleDetails = lazy(() => import(/* webpackChunkName: "VehicleDetails" */ "../pages/Vehicle/details"));
//ProformaInvoiceListCrmIT
const ProformaInvoiceListCrmIT = lazy(() => import(/* webpackChunkName: "ProformaInvoiceListCrmIT" */ "../pages/ProformaInvoices/InvoiceList"));
const ProformaInvoiceDetails = lazy(() => import(/* webpackChunkName: "ProformaInvoiceDetails" */ "../pages/ProformaInvoices/InvoiceDetails"));
const ProformaInvoiceCreateCrmIT = lazy(() => import(/* webpackChunkName: "ProformaInvoiceCreateCrmIT" */ "../pages/ProformaInvoices/InvoiceCreate"));
//CompanyRecentActivityList
const CompanyRecentActivityList = lazy(() => import(/* webpackChunkName: "CompanyRecentActivityList" */ "../pages/CompanyRecentActivity/index"));
const SingleProduct = lazy(() => import(/* webpackChunkName: "SingleProduct" */ "../pages/Product/details"));
const CustomPrice = lazy(() => import(/* webpackChunkName: "CustomPrice" */ "../pages/Product/CustomPrice"));
//AllChecklistList
const AllChecklistList = lazy(() => import(/* webpackChunkName: "AllChecklistList" */ "../pages/Checklist/AllCheklists"));
//ChecklistBuilder
const ChecklistBuilderPage = lazy(() => import(/* webpackChunkName: "ChecklistBuilderPage" */ "../pages/ChecklistBuilder/ChecklistBuilderPage"));
const ChecklistTemplateListPage = lazy(() => import(/* webpackChunkName: "ChecklistTemplateListPage" */ "../pages/ChecklistBuilder/ChecklistTemplateListPage"));
//PersonList
const PersonList = lazy(() => import(/* webpackChunkName: "PersonList" */ "../pages/Person/list"));
//FileUpload
const FileUpload = lazy(() => import(/* webpackChunkName: "FileUpload" */ "../pages/FileUpload"));
//DataImportCenter
const DataImportCenter = lazy(() => import(/* webpackChunkName: "DataImportCenter" */ "../pages/DataImportCenter"));
const Reports = lazy(() => import(/* webpackChunkName: "Reports" */ "../pages/Reports"));
//Export
const Export = lazy(() => import(/* webpackChunkName: "Export" */ "../pages/Exports"));
//PersonDetails
const PersonDetails = lazy(() => import(/* webpackChunkName: "PersonDetails" */ "../pages/Person/details"));
//LeaveRequests
const LeaveRequests = lazy(() => import(/* webpackChunkName: "LeaveRequests" */ "../pages/Staff/details/LeaveRequests"));
//LeaveAllowance
const LeaveAllowance = lazy(() => import(/* webpackChunkName: "LeaveAllowance" */ "../pages/Staff/details/LeaveAllowance"));
//PrototypeJobList
const PrototypeJobList = lazy(() => import(/* webpackChunkName: "PrototypeJobList" */ "../pages/Prototyping/job/list"));
//StaffLeave
const StaffLeave = lazy(() => import(/* webpackChunkName: "StaffLeave" */ "../pages/Staff/StaffLeave"));
//EmailDecisionMakingPage
const EmailDecisionMakingPage = lazy(() => import(/* webpackChunkName: "EmailDecisionMakingPage" */ "../pages/Staff/StaffLeave/EmailDecisionMakingPage"));
//StaffLeaveDecisionList
const StaffLeaveDecisionList = lazy(() => import(/* webpackChunkName: "StaffLeaveDecisionList" */ "../pages/Staff/StaffLeave/StaffLeaveDecisionList"));
//StaffLeaveOverview
const StaffLeaveOverview = lazy(() => import(/* webpackChunkName: "StaffLeaveOverview" */ "../pages/Staff/StaffLeave/StaffLeaveOverview"));
//MasterErrorLogList
const MasterErrorLogList = lazy(() => import(/* webpackChunkName: "MasterErrorLogList" */ "../pages/BackEnd/MasterErrorLog"));
//StockLocationList
const StockLocationList = lazy(() => import(/* webpackChunkName: "StockLocationList" */ "../pages/StockControl/StockLocationList"));
//GuestPaymentList
const GuestPaymentList = lazy(() => import(/* webpackChunkName: "GuestPaymentList" */ "../pages/EventPreOrder/GuestPaymentList"));
//StockTransactionList
const StockTransactionList = lazy(() => import(/* webpackChunkName: "StockTransactionList" */ "../pages/StockControl/StockTransactionList"));
//ReportABug
const ReportABug = lazy(() => import(/* webpackChunkName: "ReportABug" */ "../pages/ReportABug"));
//EventPreOrderGroupList
const EventPreOrderGroupList = lazy(() => import(/* webpackChunkName: "EventPreOrderGroupList" */ "../pages/EventPreOrder/EvenPreOrderGroup/List"));
//TimeEntriesAddInBulk
const TimeEntriesAddInBulk = lazy(() => import(/* webpackChunkName: "TimeEntriesAddInBulk" */ "../pages/TimeEntries/TimeEntriesAddInBulk"));
//StandAlonePaymentPage
const StandAlonePaymentPage = lazy(() => import(/* webpackChunkName: "StandAlonePaymentPage" */ "../pages/StandAlonePaymentPage"));
//SalesOrderList
const SalesOrderList = lazy(() => import(/* webpackChunkName: "SalesOrderList" */ "../pages/SalesOrder/SalesOrderList"));
const SalesOrderCreate = lazy(() => import(/* webpackChunkName: "SalesOrderCreate" */ "../pages/SalesOrder/SalesOrderCreate"));
const SalesOrderDetails = lazy(() => import(/* webpackChunkName: "SalesOrderDetails" */ "../pages/SalesOrder/SalesOrderDetails"));
const SalesOrderBillOfMaterials = lazy(() => import(/* webpackChunkName: "SalesOrderBillOfMaterials" */ "../pages/SalesOrder/BillOfMaterials"));
//SERP Rank Tracking
const CallInboundList = lazy(() => import(/* webpackChunkName: "CallInboundList" */ "../pages/CallInbound/list"));
const EcommerceStoreList = lazy(() => import(/* webpackChunkName: "EcommerceStoreList" */ "../pages/EcommerceStore/list"));
const EcommerceConsole = lazy(() => import(/* webpackChunkName: "EcommerceConsole" */ "../pages/EcommerceConsole"));
const CustomerPortalConsole = lazy(() => import(/* webpackChunkName: "CustomerPortalConsole" */ "../pages/CustomerPortalConsole")); // Change #100781
const SerpReportsList = lazy(() => import(/* webpackChunkName: "SerpReportsList" */ "../pages/SerpReports/list"));
const SerpReportForm = lazy(() => import(/* webpackChunkName: "SerpReportForm" */ "../pages/SerpReports/form"));
const SerpReportDetail = lazy(() => import(/* webpackChunkName: "SerpReportDetail" */ "../pages/SerpReports/detail"));
//Meeting AI (notetaker)
const MeetingAiList = lazy(() => import(/* webpackChunkName: "MeetingAiList" */ "../pages/MeetingAi/list"));
const MeetingAiDetail = lazy(() => import(/* webpackChunkName: "MeetingAiDetail" */ "../pages/MeetingAi/detail"));
const MeetingAiSettings = lazy(() => import(/* webpackChunkName: "MeetingAiSettings" */ "../pages/MeetingAi/settings"));
const SalesOrderItemList = lazy(() => import(/* webpackChunkName: "SalesOrderItemList" */ "../pages/SalesOrder/SalesOrderItems"));
const ReservedStockList = lazy(() => import(/* webpackChunkName: "ReservedStockList" */ "../pages/StockControl/ReservedStockList"));
const OpportunitiesReportPage = lazy(() => import(/* webpackChunkName: "OpportunitiesReportPage" */ "../pages/Opportunities/ReportPage"));
const GroupEventDetailsAdmin = lazy(() => import(/* webpackChunkName: "GroupEventDetailsAdmin" */ "../pages/EventPreOrder/EvenPreOrderGroup/Details"));
const PurchaseOrderDetails = lazy(() => import(/* webpackChunkName: "PurchaseOrderDetails" */ "../pages/PurchaseOrder/details"));
const CreatePurchaseOrder = lazy(() => import(/* webpackChunkName: "CreatePurchaseOrder" */ "../pages/PurchaseOrder/editCreate/Create"));

//UserReportList
const UserReportList = lazy(() => import(/* webpackChunkName: "UserReportList" */ "../pages/BackEnd/UserReport/list"));
//UserActivityList
const UserActivityList = lazy(() => import(/* webpackChunkName: "UserActivityList" */ "../pages/BackEnd/UserActivity/list"));
//StaffDirectory
const StaffDirectory = lazy(() => import(/* webpackChunkName: "StaffDirectory" */ "../pages/Staff/StaffDirectory/index"));
//FoodPreOrderShiftReportDashboard
const FoodPreOrderShiftReportDashboard = lazy(() => import(/* webpackChunkName: "FoodPreOrderShiftReportDashboard" */ "../pages/EventPreOrder/ShiftReports/dashboard/index"));
//ChatCRMit
const ChatCRMit = lazy(() => import(/* webpackChunkName: "ChatCRMit" */ "../pages/Prototyping/ChatCRMit/index"));
//VoiceToTextAI
const VoiceToTextAI = lazy(() => import(/* webpackChunkName: "VoiceToTextAI" */ "../pages/Prototyping/VoiceToText/index"));
//ClockInOut kiosk + Shift Time Track (prototype)
// Change #100769 - event door check-in, full-screen handheld app (public route = no chrome, still uses the JWT)
const EventCheckIn = lazy(() => import(/* webpackChunkName: "EventCheckIn" */ "../pages/EventCheckIn"));
const ClockInOutKiosk = lazy(() => import(/* webpackChunkName: "ClockInOutKiosk" */ "../pages/Prototyping/ClockInOut/index"));
// Change #100130 - the real attendance screen. /shift-time-track (the old
// localStorage prototype with made-up staff) now opens it too.
const StaffAttendance = lazy(() => import(/* webpackChunkName: "StaffAttendance" */ "../pages/StaffAttendance"));
//MessagingService
const MessagingService = lazy(() => import(/* webpackChunkName: "MessagingService" */ "../pages/MessagingService/mainPage/index"));
//CompanyEarningsReport
const CompanyEarningsReport = lazy(() => import(/* webpackChunkName: "CompanyEarningsReport" */ "../pages/CompanyEarningsReport/index"));
//PaymentsCollection
//ProductBOMPage
const ProductBOMPage = lazy(() => import(/* webpackChunkName: "ProductBOMPage" */ "../pages/BOM/index"));
const PaymentsCollection = lazy(() => import(/* webpackChunkName: "PaymentsCollection" */ "../pages/public/paymentsCollection/index"));
const ManualPaymentPage = lazy(() => import(/* webpackChunkName: "ManualPaymentPage" */ "../pages/public/manualPayment/index"));
const PurchaseDraftList = lazy(() => import(/* webpackChunkName: "PurchaseDraftList" */ "../pages/PurchaseDraft/list"));
const PurchaseDraftDetails = lazy(() => import(/* webpackChunkName: "PurchaseDraftDetails" */ "../pages/PurchaseDraft/details"));
const CreatePurchaseDraft = lazy(() => import(/* webpackChunkName: "CreatePurchaseDraft" */ "../pages/PurchaseDraft/editCreate/Create"));
const PaymentRequestList = lazy(() => import(/* webpackChunkName: "PaymentRequestList" */ "../pages/paymentRequest/paymentRequestList"));
const BadDebtList = lazy(() => import(/* webpackChunkName: "BadDebtList" */ "../pages/BadDebt")); // Change #100090
const HMRC = lazy(() => import(/* webpackChunkName: "HMRC" */ "../pages/HMRC"));
const TableReservation = lazy(() => import(/* webpackChunkName: "TableReservation" */ "../pages/OnBoarding/tableReservation"));
const DataImportPage = lazy(() => import(/* webpackChunkName: "DataImportPage" */ "../pages/DataImport"));

const InvoiceDraftList = lazy(() => import(/* webpackChunkName: "InvoiceDraftList" */ "../pages/InvoicesDraft/InvoiceList"));
const TestingPublicUrl = lazy(() => import(/* webpackChunkName: "TestingPublicUrl" */ "../pages/public/testing"));
const InvoiceDraftDetails = lazy(() => import(/* webpackChunkName: "InvoiceDraftDetails" */ "../pages/InvoicesDraft/InvoiceDetails"));
const InvoiceDraftCreate = lazy(() => import(/* webpackChunkName: "InvoiceDraftCreate" */ "../pages/InvoicesDraft/InvoiceCreate"));
const StatusKanban = lazy(() => import(/* webpackChunkName: "StatusKanban" */ "../pages/Tasks/StatusKanBan"));
const EcommercePage = lazy(() => import(/* webpackChunkName: "EcommercePage" */ "../pages/ecommerce"));
const EventMenuList = lazy(() => import(/* webpackChunkName: "EventMenuList" */ "../pages/EventPreOrder/EventMenuV2/list"));
const EventMenuDetail = lazy(() => import(/* webpackChunkName: "EventMenuDetail" */ "../pages/EventPreOrder/EventMenuV2"));
// Task 24825 - upload an existing menu document and review what it found.
const EventMenuAiImport = lazy(() => import(/* webpackChunkName: "EventMenuAiImport" */ "../pages/EventPreOrder/EventMenuV2/AiMenuImport"));
const ReferralHub = lazy(() => import(/* webpackChunkName: "ReferralHub" */ "../pages/Referrals"));
const DailyPlannerV2 = lazy(() => import(/* webpackChunkName: "DailyPlannerV2" */ "../pages/DailyPlanner/v2"));
const MRPOrderPage = lazy(() => import(/* webpackChunkName: "MRPOrderPage" */ "../pages/BOM/MRPOrder"));
const EcommerceAdminDashboard = lazy(() => import(/* webpackChunkName: "EcommerceAdminDashboard" */ "../pages/ecommerce/admin"));
const SocialMediaManagement = lazy(() => import(/* webpackChunkName: "SocialMediaManagement" */ "../pages/SocialMediaManagment"));
// Task 24873 - the OAuth landing page. Same chunk as the calendar it belongs to.
const SocialMediaConnectCallback = lazy(() => import(/* webpackChunkName: "SocialMediaManagement" */ "../pages/SocialMediaManagment/SocialMediaConnectCallback"));
const GuestTableReservationDetails = lazy(() => import(/* webpackChunkName: "GuestTableReservationDetails" */ "../pages/BookATable/GuestTableReservationDetails"));
//StaffToStaffSkillSetList
const StaffToStaffSkillSetList = lazy(() => import(/* webpackChunkName: "StaffToStaffSkillSetList" */ "../pages/Staff/list/SkillSetList"));
// Change #100459
const StaffSkillPoints = lazy(() => import(/* webpackChunkName: "StaffSkillPoints" */ "../pages/Staff/SkillPoints"));
const StaffPlanner = lazy(() => import(/* webpackChunkName: "StaffPlanner" */ "../pages/StaffPlanner"));
const ManageYourMarketingPreference = lazy(() => import(/* webpackChunkName: "ManageYourMarketingPreference" */ "../pages/EmailMarketing/public/manageYourMarketingPreference"));
const MarketingHome = lazy(() => import(/* webpackChunkName: "MarketingHome" */ "../pages/Marketing/index"));
const LocalMarketingManager = lazy(() => import(/* webpackChunkName: "LocalMarketingManager" */ "../pages/Marketing/LocalMarketingManager"));
const HmrcHubPage = lazy(() => import(/* webpackChunkName: "HmrcHubPage" */ "../pages/HMRC/HUB/HmrcHubPage"));
const LoyaltyPublicLogin = lazy(() => import(/* webpackChunkName: "LoyaltyPublicLogin" */ "../pages/Loyalty/Public/Login"));
const LoyaltyPublicDashboard = lazy(() => import(/* webpackChunkName: "LoyaltyPublicDashboard" */ "../pages/Loyalty/Public/Dashboard"));
const CustomerPortal = lazy(() => import(/* webpackChunkName: "CustomerPortal" */ "../pages/CustomerPortal"));
const PortalProfiles = lazy(() => import(/* webpackChunkName: "PortalProfiles" */ "../pages/Settings/company/PortalProfiles"));
const LeadsModule = lazy(() => import(/* webpackChunkName: "LeadsModule" */ "../pages/Leads"));
const LeadDashboardPage = lazy(() => import(/* webpackChunkName: "LeadDashboardPage" */ "../pages/Leads/LeadDashboardPage"));
const LeadListPage = lazy(() => import(/* webpackChunkName: "LeadListPage" */ "../pages/Leads/LeadListPage"));
const LeadDetailPage = lazy(() => import(/* webpackChunkName: "LeadDetailPage" */ "../pages/Leads/LeadDetailPage"));
//POSSettingsPage
const POSHome = lazy(() => import(/* webpackChunkName: "POSHome" */ "../pages/POS/POSHome"));
const POSSettingsPage = lazy(() => import(/* webpackChunkName: "POSSettingsPage" */ "../pages/POS/Settings/POSSettingsPage"));

const RestaurantHomePage = lazy(() => import(/* webpackChunkName: "RestaurantHomePage" */ "../pages/POS/Restaurant/ RestaurantHomePage"));
const KdsScreen = lazy(() => import(/* webpackChunkName: "KdsScreen" */ "../pages/POS/KDS"));
const CafeQuickOrderPage = lazy(() => import(/* webpackChunkName: "CafeQuickOrderPage" */ "../pages/POS/Cafe/CafeQuickOrderPage"));
const EmailCampaignManager = lazy(() => import(/* webpackChunkName: "EmailCampaignManager" */ "../pages/EmailCampaignManager"));
const TemplatesList = lazy(() => import(/* webpackChunkName: "TemplatesList" */ "../pages/EmailCampaignManager/views/TemplatesList"));
const SpinTheWhealPage = lazy(() => import(/* webpackChunkName: "SpinTheWhealPage" */ "../pages/SpinTheWheal"));
const BankTransactions = lazy(() => import(/* webpackChunkName: "BankTransactions" */ "../pages/Prototyping/bankTransactions"));
const PosStoreBuilder = lazy(() => import(/* webpackChunkName: "PosStoreBuilder" */ "../pages/POS/Settings/PosStoreBuilder"));
const LeadCentrePage = lazy(() => import(/* webpackChunkName: "LeadCentrePage" */ "../pages/Leads/Hub/LeadCentrePage"));
const LeadHubPage = lazy(() => import(/* webpackChunkName: "LeadHubPage" */ "../pages/Leads/LeadHubPage"));
const AutomationPage = lazy(() => import(/* webpackChunkName: "AutomationPage" */ "../pages/Automation/AutomationPage"));
const CatchAllManagement = lazy(() => import(/* webpackChunkName: "CatchAllManagement" */ "../pages/CatchAllManagement"));
const AccountantDashboard = lazy(() => import(/* webpackChunkName: "AccountantDashboard" */ "../pages/AccountantDashboard"));
const FormBuilderPage = lazy(() => import(/* webpackChunkName: "FormBuilderPage" */ "../pages/FormBuilder/FormBuilderPage"));
const FormsList = lazy(() => import(/* webpackChunkName: "FormsList" */ "../pages/Forms/list"));
const FormSubmissions = lazy(() => import(/* webpackChunkName: "FormSubmissions" */ "../pages/Forms/submissions"));
const FormSubmissionPage = lazy(() => import(/* webpackChunkName: "FormSubmissionPage" */ "../pages/Forms/submission"));
const FormFill = lazy(() => import(/* webpackChunkName: "FormFill" */ "../pages/Forms/fill"));
// Task 24903 - a customer's own copy of a form assigned to them.
const FormAssignment = lazy(() => import(/* webpackChunkName: "FormAssignment" */ "../pages/Forms/assignment"));
// Change #100777 - customer self-book link (public).
const SelfBookPage = lazy(() => import(/* webpackChunkName: "SelfBookPage" */ "../pages/SelfBook"));
const PdfTemplateList = lazy(() => import(/* webpackChunkName: "PdfTemplateList" */ "../pages/PdfTemplate/list"));
const PdfDesigner = lazy(() => import(/* webpackChunkName: "PdfDesigner" */ "../pages/PdfTemplate/designer"));
const ESignList = lazy(() => import(/* webpackChunkName: "ESignList" */ "../pages/ESign/list"));
const ESignBuilder = lazy(() => import(/* webpackChunkName: "ESignBuilder" */ "../pages/ESign/builder"));
const ESignPublicPage = lazy(() => import(/* webpackChunkName: "ESignPublicPage" */ "../pages/ESignPublic"));
const PublicFormPage = lazy(() => import(/* webpackChunkName: "PublicFormPage" */ "../pages/FormPublic/PublicFormPage"));
const CustomerSelfServiceWidget = lazy(() => import(/* webpackChunkName: "CustomerSelfServiceWidget" */ "../pages/CustomerSelfServiceWidget"));
const FieldServiceDispatchPrototype = lazy(() => import(/* webpackChunkName: "FieldServiceDispatchPrototype" */ "../pages/FieldServiceDispatch"));
const DispatchBoards = lazy(() => import(/* webpackChunkName: "DispatchBoards" */ "../pages/DispatchBoards"));
const WifiAccessPointsPrototype = lazy(() => import(/* webpackChunkName: "WifiAccessPointsPrototype" */ "../pages/WifiAccessPoints"));
//ReviewsCentre
const ReviewsCentre = lazy(() => import(/* webpackChunkName: "ReviewsCentre" */ "../pages/ReviewsCentre"));
const companyName = JSON.parse(localStorage.getItem("authUser"))
  ?.get_company_data?.Company_BusinessName?.toLowerCase()
  .replace(/ /g, "-");
// ?.replace(" ", "-")
// ?.replace(" ", "-")
// ?.replace(" ", "-");
console.log("companyName", companyName);
const authProtectedRoutes = [
  //Onboarding checklist templates
  {
    path: "/onboarding/templates",
    component: OnboardingTemplates,
  },
  //FieldServiceDispatchPrototype
  {
    path: "/field-service-dispatch/:id",
    component: FieldServiceDispatchPrototype,
  },
  //Dispatch board management (create/edit boards behind /field-service-dispatch/:id)
  {
    path: "/dispatch-boards",
    component: DispatchBoards,
  },
  //WifiAccessPointsPrototype
  {
    path: "/wifi-access-points/:id",
    component: WifiAccessPointsPrototype,
  },
  {
    path: "/wifi-access-points/:id/:tab",
    component: WifiAccessPointsPrototype,
  },
  //VideoCall
  {
    path: "/video-call/:roomId",
    component: VideoCallPage,
  },
  //Reviews Centre
  {
    path: "/reviews-centre/:tab",
    component: ReviewsCentre,
  },
  {
    path: "/reviews-centre",
    component: ReviewsCentre,
  },
  //Form Builder
  {
    path: "/form-list",
    component: FormsList,
  },
  {
    path: "/form-builder",
    component: FormBuilderPage,
  },
  {
    path: "/form-builder/:id",
    component: FormBuilderPage,
  },
  {
    path: "/form-submissions/:id",
    component: FormSubmissions,
  },
  // Change #100517 - one submission on a page of its own (tab in the URL).
  {
    path: "/form-submission/:id/:tab",
    component: FormSubmissionPage,
  },
  {
    path: "/form-submission/:id",
    component: FormSubmissionPage,
  },
  {
    path: "/form-fill/:id",
    component: FormFill,
  },
  //PDF Designer (PdfTemplate)
  {
    path: "/pdf-designer",
    component: PdfTemplateList,
  },
  {
    path: "/pdf-designer/:id",
    component: PdfDesigner,
  },
  //E-Sign (envelope list + builder)
  {
    path: "/e-sign-list",
    component: ESignList,
  },
  {
    path: "/e-sign-envelope/:id",
    component: ESignBuilder,
  },
  //Automation
  {
    path: "/automation",
    component: AutomationPage,
  },
  // --- Email Marketing Manager ---
  { path: "/email-marketing", component: EmailCampaignManager },
  { path: "/email-marketing/templates", component: EmailCampaignManager },
  { path: "/email-marketing/templates/new", component: EmailCampaignManager },
  {
    path: "/email-marketing/templates/edit/:id",
    component: EmailCampaignManager,
  },
  { path: "/email-marketing/campaigns", component: EmailCampaignManager },
  { path: "/email-marketing/automations", component: EmailCampaignManager },
  {
    path: "/email-marketing/automations/edit/:id",
    component: EmailCampaignManager,
  },
  // ==========================================
  // 1. SPECIFIC/STATIC ROUTES (Must go first!)
  // ==========================================
  {
    path: "/possystem/settings/store-builder",
    component: PosStoreBuilder,
  },
  {
    path: "/possystem/settings",
    component: POSSettingsPage,
  },
  {
    // If restaurant doesn't use a dynamic ID yet, it goes here
    path: "/possystem/restaurant",
    component: RestaurantHomePage,
  },

  // ==========================================
  // 2. DYNAMIC ROUTES (Must go after static routes)
  // ==========================================
  {
    // Because 'settings' and 'restaurant' are caught above,
    // this will only catch actual IDs like /possystem/1
    path: "/possystem/:id",
    component: CafeQuickOrderPage,
  },

  // ==========================================
  // 3. HOME / INDEX (Must go last)
  // ==========================================
  {
    path: "/possystem",
    component: POSHome,
  },

  // (Optional) Keep these temporarily if you have old links you haven't updated yet,
  // otherwise you can safely delete them!
  { path: "/pos", component: POSHome },
  { path: "/pos/cafe/:id", component: CafeQuickOrderPage },
  { path: "/pos/restaurant", component: RestaurantHomePage },
  { path: "/pos/restaurant/:id", component: RestaurantHomePage },
  { path: "/pos/kds/:id", component: KdsScreen },
  { path: "/pos/kds", component: KdsScreen },
  { path: "/possystem/kds/:id", component: KdsScreen },
  { path: "/pos/settings/store-builder", component: PosStoreBuilder },
  // Leads
  {
    path: "/leads/dashboard",
    component: LeadDashboardPage,
  },
  {
    path: "/leads/list",
    component: LeadListPage,
  },
  {
    path: "/leads/hub",
    component: LeadHubPage,
  },
  {
    path: "/leads/lead/:id",
    component: LeadDetailPage,
  },
  {
    path: "/leads",
    exact: true,
    component: LeadsModule,
  },
  //Marketing
  {
    path: "/marketing",
    component: MarketingHome,
  },
  {
    path: "/marketing/local-marketing-manager",
    component: LocalMarketingManager,
  },
  ///mrp-order/:id
  //mrp-order
  {
    // Task 24873 - where the social platforms redirect back to after consent.
    // The channel is identified by the state nonce in the query string, not by
    // the path, so one registered redirect URI serves every tenant.
    path: "/social-media-connect",
    component: SocialMediaConnectCallback,
  },
  {
    path: "/social-media-management/:params?",
    component: SocialMediaManagement,
  },
  {
    path: `/mrp-order/:id`,
    component: MRPOrderPage,
  },
  //ReferralHub
  {
    path: "/referral-hub/:tab/:option",
    component: ReferralHub,
  },
  //BOM

  {
    path: "/product-bom/:bomId/:tabview",
    component: ProductBOMPage,
  },
  {
    path: "/product-bom",
    component: ProductBOMPage,
  },
  //DataImportPage
  {
    path: "/data-import",
    component: DataImportPage,
  },
  //HMRC
  {
    path: "/hmrc-hub",
    component: HmrcHubPage,
  },
  //HMRC hmrc?code=XXXXXX
  {
    path: "/hmrc/:section/:code",
    component: HMRC,
  },
  {
    path: "/hmrc",
    component: HMRC,
  },
  //paymentsRequest
  {
    path: "/payment-request-list/:tab",
    component: PaymentRequestList,
  },
  {
    path: "/payment-request-list",
    component: PaymentRequestList,
  },
  // Bad debt write-offs (Change #100090)
  { path: "/bad-debt-list/:id", component: BadDebtList },
  { path: "/bad-debt-list", component: BadDebtList },
  //CompanyEarningsReport
  {
    path: "/company-earnings-report",
    component: CompanyEarningsReport,
  },
  //MessagingService
  {
    path: "/messaging-service/:id/:option",
    component: MessagingService,
  },
  {
    path: "/messaging-service",
    component: MessagingService,
  },
  //VoiceToTextAI
  {
    path: "/voice-to-text",
    component: VoiceToTextAI,
  },
  //ChatCRMit
  {
    path: "/chat-crmit",
    component: ChatCRMit,
  },
  //FoodPreOrderShiftReportDashboard
  {
    path: "/food-pre-order-shift-report-dashboard",
    component: FoodPreOrderShiftReportDashboard,
  },
  //StaffDirectory
  {
    path: "/staff-directory",
    component: StaffDirectory,
  },
  {
    path: "/staff-skill-set-list",
    component: StaffToStaffSkillSetList,
  },
  // Change #100459 - points per staff skill, grouped by skill
  {
    path: "/staff-skill-points",
    component: StaffSkillPoints,
  },
  //TimeEntriesAddInBulk
  {
    path: "/time-entries-add-in-bulk",
    component: TimeEntriesAddInBulk,
  },
  //GuestPaymentList
  {
    path: "/guest-payment-list",
    component: GuestPaymentList,
  },
  //StockLocationList
  {
    path: "/stock-location-list",
    component: StockLocationList,
  },
  //StockTransactionList
  {
    path: "/stock-transaction-list",
    component: StockTransactionList,
  },
  //Export
  { path: "/export", component: Export },
  //PersonList
  { path: "/person-list", component: PersonList },
  // Change #100518 - the name the menu uses; same page.
  { path: "/contact-person-list", component: PersonList },
  //PersonDetails
  { path: "/person-details/:id/:tab", component: PersonDetails },
  //Reports — hub with a report selected by URL slug (/reports/<slug>).
  // Bare /reports redirects to the first report inside the Reports component.
  { path: "/reports/:reportSlug", component: Reports },
  { path: "/reports", component: Reports },
  //File Upload
  //Data Import Center
  { path: "/data-import-center", component: DataImportCenter },
  // Back-compat: old upload path now redirects to the Data Import Center
  {
    path: "/file-upload",
    exact: true,
    component: () => <Redirect to="/data-import-center" />,
  },
  // Legacy customer upload still reachable directly
  { path: "/customer-upload", component: FileUpload },
  //AllChecklistList
  { path: "/checklist-list", component: AllChecklistList },
  //ChecklistBuilder (templates hub + new + edit)
  { path: "/checklist-templates", component: ChecklistTemplateListPage },
  { path: "/checklist-builder/:id", component: ChecklistBuilderPage },
  { path: "/checklist-builder", component: ChecklistBuilderPage },
  //CompanyRecentActivityList
  {
    path: "/my-recent-activity-list",
    component: CompanyRecentActivityList,
  },
  //Partners
  //Partners List
  { path: "/partners-list", component: PartnersList },
  //Vehicle
  //Vehicle List (gated behind the Customer Vehicle Management module)
  {
    path: "/vehicle-list",
    component: () => (
      <ModuleGate
        code={SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE}
        moduleName="Customer Vehicle Management"
      >
        <VehicleList />
      </ModuleGate>
    ),
  },
  //Vehicle Details (gated behind the Customer Vehicle Management module)
  {
    path: "/vehicle-details/:id/:tab",
    component: () => (
      <ModuleGate
        code={SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE}
        moduleName="Customer Vehicle Management"
      >
        <VehicleDetails />
      </ModuleGate>
    ),
  },
  //Company Vehicle (fleet)
  //Company Vehicle List
  { path: "/companyvehicle-list", component: CompanyVehicleList },
  { path: "/companyvehicles", component: CompanyVehicleList },
  //Company Vehicle Details
  { path: "/companyvehicle-details/:id/:tab", component: CompanyVehicleDetails },
  // API recent-activity UrlLink targets - keep these paths registered
  { path: "/companyvehicles/:id/view", component: CompanyVehicleDetails },
  { path: "/single-companyvehicle/:id", component: CompanyVehicleDetails },
  //VoiceToText
  { path: "/voice-to-text", component: VoiceToText },

  // Daily Planner
  { path: "/daily-planner/:option", component: DailyPlanner },

  { path: "/daily-planner", component: DailyPlanner },
  { path: "/daily-planner2/:tab/:option", component: DailyPlannerV2 },
  //gps
  { path: "/gps", component: GPS },
  //ClosestToCustomer
  { path: "/closest-to-customer", component: ClosestToCustomer },

  //GiftVoucher
  { path: "/gift-voucher", component: GiftVoucher },
  //BackEnd
  //MasterErrorLogList
  { path: "/master-error-log-list", component: MasterErrorLogList },
  //SlowQueryMonitor
  { path: "/slow-query-monitor", component: SlowQueryMonitor },
  // CompanyDetails
  // Change #100463 - a sub tab inside a tab (e.g. /company-details/4/Users/active)
  { path: "/company-details/:id/:tab/:subtab", component: CompanyDetails },
  { path: "/company-details/:id/:tab", component: CompanyDetails },
  //CompanyReportList
  { path: "/company-report-list", component: CompanyReportList },
  //UserReportList
  {
    path: "/user-report-list",
    component: UserReportList,
  },
  //UserActivityList
  {
    path: "/user-activity-list",
    component: UserActivityList,
  },
  //Company Usage List
  { path: "/company-usage-list", component: CompanyUsageList },
  // System Wallet (literal paths before the /:companyId param route)
  { path: "/system-wallet-service-types", component: SystemWalletServiceTypes },
  { path: "/system-wallet-service-rates", component: SystemWalletServiceRates },
  { path: "/system-wallet/:companyId", component: SystemWalletDetail },
  { path: "/system-wallets", component: SystemWalletList },
  // Book A Table Admin
  {
    path: "/reservation-diary/:id/:section/:tab?",
    component: BookATableAdmin,
  },
  { path: "/reservation-diary/:id/:option/", component: BookATableAdmin },
  { path: "/reservation-diary", component: BookATableAdmin },
  // Reservation Diary V2 (modern prototype - Task 24311). Optional section/tab
  // segments so it accepts the same URL shape as the classic diary
  // (/reservation-diary-v2/:id and /reservation-diary-v2/:id/diary/standard).
  // Settings must come first - the catch-all below would swallow it.
  {
    path: "/reservation-diary-v2/:id/settings/:tab?",
    component: ReservationDiaryV2Settings,
  },
  { path: "/reservation-diary-v2/:id/:section?/:tab?", component: ReservationDiaryV2 },
  // SingleEventAdmin
  { path: "/single-event-admin/:id/:tab", component: SingleEventAdmin },
  //Event Pre Order
  { path: "/EventMenuV2", component: EventMenuList },
  // Task 24825 - MUST stay above /EventMenuV2/:id, which would otherwise
  // swallow it and try to load a menu with the id "ai-import".
  { path: "/EventMenuV2/ai-import", component: EventMenuAiImport },
  { path: "/EventMenuV2/:id", component: EventMenuDetail },
  { path: "/event-pre-order", component: EventPreOrder },
  { path: "/event-pre-order-menu", component: EventPreorderMenu },

  //weekly
  { path: "/event-pre-order-weekly", component: EventPreOrderWeekly },
  //EventPreOrderGroupList
  { path: "/event-pre-order-group-list", component: EventPreOrderGroupList },
  { path: "/group-event-admin/:id/:tab", component: GroupEventDetailsAdmin },
  //Appointment routes
  //AppointmentList
  { path: "/appointment-list", component: AppointmentList },
  // CreateEditStaffIncome
  { path: "/create-edit-staff-income", component: CreateEditStaffIncome },
  {
    path: "/staff-income-details/:id/:option",
    component: StaffIncomeDetails,
  },
  //StaffLeave
  { path: "/staff-holiday-record", component: StaffLeave },
  //StaffLeaveDecisionList
  {
    path: "/staff-leave-decision-list",
    component: StaffLeaveDecisionList,
  },
  //StaffLeaveOverview
  {
    path: "/staff-leave-overview",
    component: StaffLeaveOverview,
  },
  //LeaveRequests
  // Task 24585 — the filter strip is linkable here too. Named :filter rather
  // than :tab so it can never be confused with the staff-details :tab segment,
  // which this same component sees when it is embedded there.
  { path: "/leave-requests-list/:filter", component: LeaveRequests },
  { path: "/leave-requests-list", component: LeaveRequests },
  //LeaveAllowance
  { path: "/leave-allowance-list", component: LeaveAllowance },
  // ReportingDashboard

  { path: "/reporting-dashboard/:id", component: ReportingDashboard },
  { path: "/reporting-dashboard", component: ReportingDashboard },
  // No Access
  { path: "/no-access/:response", component: NoAccess },
  //YearEndPeriodExport
  { path: "/year-end-period-export", component: YearEndPeriodExport },
  // VatPeriodExport
  { path: "/vat-period-export", component: VatPeriodExport },
  // Provider
  { path: "/provider-list", component: ProviderList },
  //Liability
  { path: "/liability-list", component: LiabilityList },
  { path: "/liability/:id/:option", component: LiabilityDetails },
  { path: "/create-liability", component: CreateLiability },
  { path: "/create-liability/:id/:option", component: CreateLiability },

  // OnBoarding
  {
    path: "/onboarding/table-reservation/:tab/:option",
    component: TableReservation,
  },
  {
    path: "/onboarding/table-reservation/:tab",
    component: TableReservation,
  },
  {
    path: "/onboarding/table-reservation",
    component: TableReservation,
  },
  { path: "/onboarding", component: OnBoarding },
  // Tasks
  { path: "/tasks", component: TasksCrmIT },
  { path: "/tasks/:id/:tab", component: SingleTask },
  // Weekly Tasks
  { path: "/weekly-tasks", component: WeeklyTasks },
  { path: "/weekly-tasks/:staff/:status/:type", component: WeeklyTasks },
  // Weekly Tasks KanBan
  { path: "/weekly-tasks-kanban", component: WeeklyTasksKanBan },
  { path: "/status-tasks-kanban", component: StatusKanban },

  // Single Tasks Page

  // Jobs

  { path: "/apps-crm-jobs-list", component: CrmJobsList },
  { path: "/uninvoiced-jobs-list", component: CrmJobsUninvoicedList },
  { path: "/job/list/stale", component: CrmJobsStaleList },
  { path: "/pdf-job-sheet/:id", component: PDFJobSheet },
  //SingleTask path needs to be added a id parameter
  { path: "/single-job/:id/:tab", component: SingleJob },
  { path: "/single-job/:id", component: SingleJob },
  // Crmit EmailInBox
  { path: "/email-prototype", component: EmailInbox },
  { path: "/crmit-email-inbox/:tab/:singleEmailId", component: CrmitMailInbox },
  { path: "/crmit-email-inbox/", component: CrmitMailInbox },
  { path: "/dashboard/builder", component: DashboardBuilder },
  { path: "/dashboard", component: CrmDashboard },
  { path: "/recently-viewed", component: RecentlyViewed },
  { path: "/report-builder", component: ReportingPage },
  { path: "/my-dashboard", component: Dashboard2ndEdition },
  //SalesOrderList
  {
    path: "/sales-order-list",
    component: SalesOrderList,
  },
  {
    path: "/sales-order-details/:id/:option",
    component: SalesOrderDetails,
  },
  {
    path: "/sales-order-bill-of-materials/:id",
    component: SalesOrderBillOfMaterials,
  },
  {
    path: "/sales-order-item-list",
    component: SalesOrderItemList,
  },
  //Inbound calls (Twilio). :phoneNumber pre-filters the list, e.g.
  ///call-inbound/+447795521453 — the routes are exact, so both are needed.
  {
    path: "/call-inbound",
    component: CallInboundList,
  },
  {
    path: "/call-inbound/:phoneNumber",
    component: CallInboundList,
  },
  //E-commerce store list (Change #100721)
  {
    path: "/ecommerce-store-list",
    component: EcommerceStoreList,
  },
  //E-commerce Console (admin back office). Routes are exact, so both are needed.
  {
    path: "/ecommerce-console/:storeId",
    component: EcommerceConsole,
  },
  {
    path: "/ecommerce-console/:storeId/:tab",
    component: EcommerceConsole,
  },
  //SERP Rank Tracking (edit route MUST precede the :tab detail route)
  {
    path: "/serp-reports",
    component: SerpReportsList,
  },
  {
    path: "/serp-report-create",
    component: SerpReportForm,
  },
  {
    path: "/serp-report/:id/edit",
    component: SerpReportForm,
  },
  {
    path: "/serp-report/:id/:tab",
    component: SerpReportDetail,
  },
  //Meeting AI (settings route MUST precede the :id/:tab detail route)
  {
    path: "/meeting-ai",
    component: MeetingAiList,
  },
  {
    path: "/meeting-ai-settings",
    component: MeetingAiSettings,
  },
  {
    path: "/meeting-ai/:id/:tab",
    component: MeetingAiDetail,
  },
  //create sales order
  {
    path: "/sales-order-create",
    component: SalesOrderCreate,
  },
  {
    path: "/sales-order-create/:id/:option",
    component: SalesOrderCreate,
  },
  //ReservedStockList
  {
    path: "/reserved-stock-list",
    component: ReservedStockList,
  },
  // invoice Draft
  //Invoices list
  { path: "/invoices-draft-list", component: InvoiceDraftList },

  {
    path: "/invoices-draft-details/:id/:option",
    component: InvoiceDraftDetails,
  },
  { path: "/invoices-draft-create", component: InvoiceDraftCreate },
  { path: "/invoices-draft-create/:id/:option", component: InvoiceDraftCreate },

  //Invoices
  //InvoiceListV2
  { path: "/invoice-list-v2", component: InvoiceListV2 },
  { path: "/crmit-invoices-list", component: InvoiceListCrmIT },
  {
    path: "/crmit-invoices-details/:id/:option",
    component: InvoiceDetailsCrmIT,
  },
  { path: "/crmit-invoices-create", component: InvoiceCreateCrmIT },
  { path: "/crmit-invoices-create/:id/:option", component: InvoiceCreateCrmIT },

  //InvoiceItemList
  { path: "/invoice-item-list", component: InvoiceItemList },
  //Proforma Invoices
  { path: "/proforma-invoices-list", component: ProformaInvoiceListCrmIT },
  {
    path: "/proforma-invoices-details/:id/:option",
    component: ProformaInvoiceDetails,
  },
  { path: "/proforma-invoices-create", component: ProformaInvoiceCreateCrmIT },
  {
    path: "/proforma-invoices-create/:id/:option",
    component: ProformaInvoiceCreateCrmIT,
  },
  // Calendar CrmIT (tabs deep-linked as /calendar-crm-it/:view, e.g. /planner)
  { path: "/calendar-crm-it/:view", component: CalendarCrmIT },
  { path: "/calendar-crm-it", component: CalendarCrmIT },
  //Supports Tickets

  //User Profile
  { path: "/profile", component: UserProfile },
  // Catch-All Management
  { path: "/catch-all-management", component: CatchAllManagement },
  // Accountant Dashboard
  { path: "/accountant-dashboard", component: AccountantDashboard },
  // Prototyping
  { path: "/prototype", component: Prototyping },
  //PrototypeJobList
  { path: "/prototype-job-list", component: PrototypeJobList },
  //Shift Time Track - retired prototype, now the real Staff Attendance screen (Change #100130)
  { path: "/shift-time-track", component: StaffAttendance },
  // Change #100130 - Staff Attendance, addressed like the staff planner:
  //   /staff-attendance/week/2026-09-21, /staff-attendance/exceptions/2026-09-21
  { path: "/staff-attendance/:view/:detail", component: StaffAttendance },
  { path: "/staff-attendance/:view", component: StaffAttendance },
  { path: "/staff-attendance", component: StaffAttendance },
  // Time Entries
  { path: "/time-entries", component: TimeEntries },
  //TimeEntriesSummary
  { path: "/time-entries-summary", component: TimeEntriesSummary },
  //Advanced Search
  { path: "/advanced-search", component: AdvancedSearch },
  //Customer Paths
  //Customer Single
  { path: "/customer-single/:id/:tab", component: CustomerSingle },
  //Customer List
  { path: "/customer-list", component: CustomerList },
  // Customer Balance List
  { path: "/customer-balance/:date", component: CustomerBalanceList },
  { path: "/customer-balance", component: CustomerBalanceList },
  // Payroll (literal paths must precede the /:id param route)
  { path: "/payroll/new", component: PayrollNewRun },
  { path: "/payroll/hmrc-settings", component: PayrollHmrcSettings },
  { path: "/payroll/payslip/:itemId", component: PayrollPayslip },
  { path: "/payroll/:id", component: PayrollRunDetail },
  { path: "/payroll", component: PayrollRunList },
  //Loyalty
  { path: "/Loyalty", component: Loyalty },
  //Loyalty Balances
  { path: "/Loyalty-balances", component: LoyaltyBalances },
  // Loyalty Vouchers
  { path: "/Loyalty-vouchers", component: LoyaltyVouchers },
  //Loayalty Dashboard
  { path: "/Loyalty-dashboard", component: LoyaltyDashboard },
  // Business Overview
  { path: "/business-overview", component: BusinessOverview },
  // Task 24742 - the finance half, on its own screen rather than bolted to the
  // bottom of the trading one.
  { path: "/finance-overview", component: FinanceOverview },
  // Recurring Revenue (tenant MRR / ARR / churn)
  { path: "/recurring-revenue", component: RecurringRevenue },
  // Platform MRR (super-admin: CRMit's own subscription revenue)
  { path: "/platform-mrr", component: PlatformMrr },
  // Loyalty Terminal
  { path: "/loyalty-terminal", component: LoyaltyTerminal },
  // Loyalty Portals (admin CRUD)
  { path: "/loyalty-portals", component: LoyaltyPortals },
  // Customer Jobs Portal — Profiles (admin CRUD)
  { path: "/portal-profiles", component: PortalProfiles },
  // Customer Portal Console, one portal (Change #100781). Routes are exact, so both are needed.
  { path: "/customer-portal-console/:portalId", component: CustomerPortalConsole },
  { path: "/customer-portal-console/:portalId/:tab", component: CustomerPortalConsole },
  // Bank
  //Bank List
  { path: "/bank-list/:options", component: BankList },
  { path: "/bank-list", component: BankList },

  //Bank Single
  { path: "/bank-single/:id/:option", component: BankSingle },
  // All Bank Transactions
  { path: "/all-bank-transactions-v2", component: BankTransactions },
  { path: "/all-bank-transactions", component: AllBankTransactions },
  // Single allocation detail (shareable deep link)
  { path: "/bank-transaction-allocation/:id", component: AllocationSingle },
  { path: "/all-bank-transactions/:id", component: AllBankTransactions },

  //FAQS CRM IT
  { path: "/faqs-crm-it", component: FaqsCrmIT },

  // Product List
  { path: "/product-list", component: ProductList },
  { path: "/product-custom-price-list", component: CustomPrice },
  { path: "/product-details/:id/:tab", component: SingleProduct },

  //Contract List
  { path: "/contract-list", component: Contract },
  { path: "/contract-items-list", component: ContractItemsList },
  { path: "/contract-items-usage-search/:id", component: ContractItemUsage },
  { path: "/contract-items-usage-search", component: ContractItemUsage },
  { path: "/contract-overview/:id/:tab", component: ContractOverview },
  { path: "/contract-overview/:id", component: ContractOverview },
  { path: "/contract-portfolio", component: ContractPortfolio },

  // Purchase List
  { path: "/purchase-list/:tab", component: PurchaseList },
  { path: "/purchase-list", component: PurchaseList },
  { path: "/purchase-order-list", component: PurchaseOrderList },
  { path: "/purchase/:id/:option", component: PurchaseDetails },
  { path: "/purchase-order/:id/:option", component: PurchaseOrderDetails },

  { path: "/purchase-item-list", component: PurchaseItemList },
  { path: "/purchase-item-list/:search", component: PurchaseItemList },
  { path: "/create-purchase", component: CreatePurchase },
  {
    path: "/create-purchase-order",
    component: CreatePurchaseOrder,
  },
  { path: "/create-purchase/:id/:option", component: CreatePurchase },
  {
    path: "/create-purchase-order/:id/:option",
    component: CreatePurchaseOrder,
  },
  //purchase draft
  {
    path: "/purchase-draft-list",
    component: PurchaseDraftList,
  },
  { path: "/purchase-draft/:id/:option", component: PurchaseDraftDetails },
  { path: "/create-purchase-draft", component: CreatePurchaseDraft },
  //Suppliers List
  { path: "/suppliers-list", component: SuppliersList },
  { path: "/purchase-invoice-links", component: PurchaseInvoiceLinks },
  { path: "/my-day/:date", component: MyDay },
  { path: "/my-day", component: MyDay },
  // Change #100670 - my assigned vehicles; the vehicle page in driver mode.
  { path: "/my-vehicles/:id/:tab", component: CompanyVehicleDetails },
  { path: "/my-vehicles/:id", component: CompanyVehicleDetails },
  { path: "/my-vehicles", component: MyVehicles },
  { path: "/supplier/:id/:tab", component: SupplierDetails },
  // Supplier Balance
  { path: "/supplier-balance-list/:date", component: SupplierBalanceList },
  { path: "/supplier-balance-list", component: SupplierBalanceList },
  // Opportunities List
  { path: "/opportunities-list", component: OpportunitiesList },
  { path: "/opportunity/:id/:tab", component: OpportunityDetails },
  {
    path: "/opportunity-reports",
    component: OpportunitiesReportPage,
  },

  // this route should be at the end of all other routes
  // Quote List
  { path: "/quote-list", component: QuoteList },
  { path: "/create-quote/create/:customerId", component: QuoteCreate },
  { path: "/create-quote", component: QuoteCreate },
  { path: "/quote/:id/:option", component: QuoteDetails },
  // Contact Person Lookup List
  { path: "/contact-person-lookup-list", component: ContactPersonLookupList },
  // Contact Person Lookup List With Filter
  {
    path: "/system/Controller_Call/lookup/ContactTelephoneNumber/:id",
    component: ContactPersonLookupList,
  },
  {
    path: "/call-screen-pop",
    component: ContactPersonLookupList,
  },
  {
    path: "/call-screen-pop/:id",
    component: ContactPersonLookupList,
  },
  // Profit And Loss
  { path: "/profit-and-loss", component: ProfitAndLoss },
  { path: "/business-profit-and-loss", component: BusinessProfitAndLoss },
  // XlsPrototyping
  { path: "/xls-prototyping", component: XlsPrototyping },

  { path: "/setup-complete", component: PaymentStatus },
  {
    path: "/settings/:mainTopTab/:activeMenu/:activeTab/:code",
    component: Settings,
  },
  { path: "/settings/:mainTopTab/:activeMenu/:activeTab", component: Settings },
  { path: "/settings/:mainTopTab/:activeMenu", component: Settings },
  { path: "/settings/:mainTopTab", component: Settings },
  { path: "/settings", component: Settings },
  // Dunning
  { path: "/dunning-list", component: DunningList },
  { path: "/dunning-preview", component: DunningPreview },
  { path: "/dunning-lock-list", component: DunningLockList },
  { path: "/dunning-single/:id/:tab", component: DunningSingle },
  //Staff Planner
  // Tasks 24865 / 24866 / 24867 - the view, the date and the List tab all live
  // in the address bar, so a planner screen can be linked to and reloaded.
  //
  //   /staff-planner                    Month, today
  //   /staff-planner/day/2026-09-21     a calendar view on a date
  //   /staff-planner/list/unassigned    the List view on one of its tabs
  //   /staff-planner/uninvoiced         (carries its own month picker)
  //
  // Three entries rather than one with optional params: every route here is
  // rendered exact, so they cannot shadow each other, and each shape is legible
  // on its own line.
  {
    path: "/staff-planner/:view/:detail",
    component: StaffPlanner,
  },
  {
    path: "/staff-planner/:view",
    component: StaffPlanner,
  },
  {
    path: "/staff-planner",
    component: StaffPlanner,
  },
  // Staff
  { path: "/staff-list", component: StaffList },
  //StaffIncomeList
  { path: "/staff-income-list/:tab", component: StaffIncomeList },
  { path: "/staff-income-list", component: StaffIncomeList },
  // Task 24578 — a tab can own a further segment for its own sub-tab, so the
  // Staff Leave sub-tabs (Overview/Calendar/Requests/Allowance) are linkable
  // and survive a refresh. Routes render with exact={true}, so each depth
  // needs its own entry.
  // Task 24585 — and one more level, for the filter strip inside a sub-tab
  // (Requests → All/Approved/Pending/Declined).
  {
    path: "/staff-details/:id/:tab/:subtab/:subsubtab",
    component: StaffDetails,
  },
  { path: "/staff-details/:id/:tab/:subtab", component: StaffDetails },
  { path: "/staff-details/:id/:tab", component: StaffDetails },
  { path: "/staff-details/:id", component: StaffDetails },
  {
    path: "/staff-qualifications-certifications",
    component: StaffQualificationsCertifications,
  },
  { path: "/credential-catalog", component: CredentialCatalog },
  { path: "/change-tracking", component: ChangeTracking },
  { path: "/customer-asset-settings", component: CustomerAssetSettings },
  { path: "/customer-asset/:id/:tab", component: CustomerAssetDetails },
  { path: "/asset-details/:id/:tab", component: AssetDetails },
  { path: "/asset-details/:id", component: AssetDetails },
  { path: "/system-device/:id/:tab", component: SystemDeviceHardwareDetails },
  { path: "/system-device/:id", component: SystemDeviceHardwareDetails },
  { path: "/guided-onboarding", component: GuidedOnboarding },
  { path: "/dashboard-upgrade-v2", component: DashboardV2 },
  { path: "/asset-list", component: AssetList },

  // Knowledgebase (Task 24574). Routes are rendered with exact={true} inside a
  // Switch in array order, so /edit must sit above the /:slug reader route or
  // "edit" would be matched as a slug.
  { path: "/knowledge-base/article/:articleId/edit", component: KnowledgeBaseArticleEdit },
  { path: "/knowledge-base/article/:articleId/:slug", component: KnowledgeBaseArticle },
  { path: "/knowledge-base/article/:articleId", component: KnowledgeBaseArticle },
  { path: "/knowledge-base/space/:spaceId", component: KnowledgeBaseSpace },
  { path: "/knowledge-base/admin", component: KnowledgeBaseAdmin },
  { path: "/knowledge-base", component: KnowledgeBase },
  { path: "/create-company", component: CreateCompany },
  { path: "/auth/register/user/:token", component: InviteJoin },
  { path: "/interm", component: IntermPage },
  { path: "/auth/name-device", component: NameDevice },
  //
  {
    path: `/ecommerce-store-admin/:company/admin`,
    component: EcommerceAdminDashboard,
  },
  {
    path: "/",
    exact: true,
    // Change #100336 - "if he visited disastercare.portal.crmit.app it takes
    // him to the dashboard page not the one set". The bare address always
    // went to /dashboard; it now goes to the person's Default landing page,
    // the OpeningUrl sign-in / company switch stored on authUser.
    component: () => <Redirect to={homeLandingPath()} />,
  },
];

function homeLandingPath() {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    let url = String(authUser?.get_staff_data?.OpeningUrl || "").trim();
    // Sign-in stores "/my-day", a company switch stores "my-day".
    if (url && !url.startsWith("/")) url = "/" + url;
    // Never bounce back to "/" (a redirect loop) or off to an auth page.
    if (!url || url === "/" || url.startsWith("/login") || url.startsWith("/logout")) {
      return "/dashboard";
    }
    return url;
  } catch (_) {
    return "/dashboard";
  }
}

const publicRoutes = [
  // Change #100769 - event door check-in. Public only so it renders without the
  // sidebar/header on a phone; the page itself sends a signed-out user to /login.
  {
    path: "/event-checkin/:id",
    component: EventCheckIn,
  },
  //Clock In/Out kiosk (full-screen, shared-device sign in/out)
  {
    path: "/clock-in-out",
    component: ClockInOutKiosk,
  },
  //Customer self-service booking widget (embeddable via iframe)
  {
    path: "/customer-self-service-widget/:id",
    component: CustomerSelfServiceWidget,
  },
  // Task 24903 - a customer's own copy of an assigned form. PUBLIC: the
  // assignment's unguessable IdExternal is the credential, and it identifies the
  // assignment rather than a customer, which is what lets this one arrive
  // prefilled where /form/:uuid deliberately cannot.
  {
    path: "/form-assignment/:token",
    component: FormAssignment,
  },
  // Change #100777 - the customer picks a time from a self-book link sent from
  // Field Service Dispatch. PUBLIC: the token names the link (and carries the
  // company), never a customer; the server decides everything but the time.
  {
    path: "/book/:token",
    component: SelfBookPage,
  },
  //Public Form (runtime for a published form; :uuid = Form.Uuid)
  {
    path: "/form/:uuid",
    component: PublicFormPage,
  },
  {
    path: "/public-form/:uuid",
    component: PublicFormPage,
  },
  //E-Sign public signer page (token from the signing email)
  {
    path: "/e-sign/:token",
    component: ESignPublicPage,
  },
  //customer jobs portal (company resolved from subdomain, e.g. escit.portal.crmit.app)
  {
    path: "/portal",
    component: CustomerPortal,
  },
  //Change #100781 - one portal per PortalProfile: /p/<PortalProfile.IdExternal>
  {
    path: "/p/:portalId",
    component: CustomerPortal,
  },
  //loyalty-reward-spinner
  {
    path: "/loyalty-reward-spinner/:id",
    component: SpinTheWhealPage,
  },
  //loyalty self-service portal (identified by portal IdExternal hash)
  {
    path: "/loyalty/:portalId/dashboard",
    component: LoyaltyPublicDashboard,
  },
  {
    path: "/loyalty/:portalId",
    component: LoyaltyPublicLogin,
  },
  // Task 24890 - the legacy bare aliases /loyalty-login and /loyalty-dashboard
  // are gone. They never worked (resolvePortalId only parses a portal hash out
  // of /loyalty/<hash>) and, because react-router v5 matches case-insensitively
  // and this public list is tested before the auth list in Routes/index.js,
  // /loyalty-dashboard was shadowing the admin /Loyalty-dashboard screen.
  //unsubscribe from email marketing
  {
    path: "/manage-your-marketing-preference/:token:/:email",
    component: ManageYourMarketingPreference,
  },
  //ecommerce
  // product detail route must be first (more specific)

  {
    path: `/ecommercestore/:companyName/:tab/:productid/:productTitle`,
    component: EcommercePage,
  },
  // NEW thank-you route: /ecommercestore/:companyName/thankyou/:orderId
  {
    path: `/ecommercestore/:companyName/thankyou/:orderId`,
    component: EcommercePage,
  },
  // generic tab route (shop, checkout, etc.)
  { path: `/ecommercestore/:companyName/:tab`, component: EcommercePage },
  //depricated now (still available but just for now
  // { path: `/${companyName}/shopping`, component: EcommercePage },

  //Testing Public URLs
  {
    path: "/testing-public-url",
    component: TestingPublicUrl,
  },
  //PaymentsCollection
  {
    path: "/payment/:token",
    component: PaymentsCollection,
  },
  //ManualPaymentPage
  {
    path: "/public/payment/manual/:companyId/:token",
    component: ManualPaymentPage,
  },
  //StandAlonePaymentPage
  {
    path: "/stand-alone-payment-page",
    component: StandAlonePaymentPage,
  },
  //ReportABug
  {
    path: "/report-a-bug",
    component: ReportABug,
  },
  // EmailDecisionMakingPage Email Decision Making Page
  {
    path: "/staff-leave-decision/:token",
    component: EmailDecisionMakingPage,
  },
  // Book A Table
  {
    path: "/reservation-details/:token",
    component: GuestTableReservationDetails,
  },

  { path: "/widget/restaurant-reservation/:externalId", component: BookATable }, // [Create New Menu Item]
  // Event Organisers Page
  {
    path: "/manage-event-anonymous/:token/:option",
    component: RegisterGuestToEvent,
  },
  { path: "/manage-event-anonymous/:token", component: RegisterGuestToEvent },

  { path: "/manage-event-anonymous/:token", component: RegisterGuestToEvent }, //

  { path: "/manage-event/:token/:option/:tab", component: OrganisersEventPage }, // { Menu Item Name: [John]}


  { path: "/manage-event/:token", component: OrganisersEventPage },
  { path: "/manage-event", component: OrganisersEventPage },
  //Food Ordering
  { path: "/food-ordering", component: FoodOrdering },

  // Authentication Page
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/register", component: Register },

  // Auth Pages
  // Verify Email /auth/verify-email/74f71e1ef548c4a0fe60b9f8170f9c22
  { path: "/auth/verify-email/:token", component: VerifyEmail },
  { path: "/auth/verify-email", component: VerifyEmail },

  // Join Company accepting invitation
  { path: "/join/:token/:email", component: InviteJoin },
  { path: "/join", component: InviteJoin },

  // Reset Password
  { path: "/auth/resetpassword/:token", component: BasicPasswResetFromEmail },
  //Payment pages
];

export { authProtectedRoutes, publicRoutes };
